import React from "react";
import { Box, Flex, Heading, Link, Text } from "theme-ui";
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Carousel from "react-multi-carousel";
import styled from '@emotion/styled';
import { colors, typography } from "../../../styles/theme";
import bullet from '../../../../static/images/bullet-icon.png';

const Products = ({ productSectionTitle, productSections }) => {
  const TopLabel = ({ label, labelColor }) => (
    <Box sx={{ ...topLabelStyles, backgroundColor: labelColor }}>
      {label}
    </Box>
  );
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  return (
    <Box
      sx={{
        "@media(max-width: 420px)": {
          px: "1.5rem",
        },
      }}
    >
      <Heading
        as="h2"
        sx={headingContainer}
        dangerouslySetInnerHTML={{ __html: productSectionTitle }}
      />
      <Box sx={styles.carouselWrapper}>
        <Carousel
          responsive={responsive}
          arrows={false}
          showDots={productSections?.length === 1 ? false : true}
          autoPlay={true}
          renderDotsOutside={true}
          additionalTransfrom={0}
          infinite
          autoPlaySpeed={5500}
          keyBoardControl
          minimumTouchDrag={80}
          slidesToSlide={1}
          renderButtonGroupOutside={true}
          customTransition="opacity 5s ease-in"
          transitionDuration={1000}
          containerClass="carousel-container"
          pauseOnHover={false}
        >
          {productSections?.map((productSection, index) => (
            <Flex key={`product-feature-${index}`} sx={featureStyle}>
              {productSection?.cardImage && (
                <GatsbyImage
                  image={getImage(productSection.cardImage)}
                  alt={productSection.title}
                  sx={{ width: "100%" }}
                />
              )}
              <Box>
                <TopLabel
                  label={productSection.title}
                  labelColor={`${productSection?.backgroundColor}200`}
                />
                <Heading as="h5" sx={{ ...typography.h5, my: "1.5rem", p: { m: 0 } }} dangerouslySetInnerHTML={{ __html: productSection.heading }} />
                <StyledUL>
                  <Text sx={{ ...typography.textMd400 }} dangerouslySetInnerHTML={{ __html: productSection.backContent }} />
                </StyledUL>
                {productSection?.learnMoreUrl && (
                  <Link href={productSection.learnMoreUrl} target="_blank" rel="noopener">
                    <Text as="h6" sx={buttonStyle}>{productSection.primaryCtaName}</Text>
                  </Link>
                )}
              </Box>
            </Flex>
          ))}
        </Carousel>
      </Box>
    </Box>
  );
};

const { headingContainer, topLabelStyles, featureStyle, buttonStyle } = {
  headingContainer: {
    ...typography.h2,
    p: { m: 0 },
    textAlign: "center",
    mb: "4rem",
  },
  topLabelStyles: {
    ...typography.textMd500,
    color: colors.black,
    borderRadius: "6.25rem",
    padding: "0.313rem 0.938rem",
    display: "inline-block",
    height: "2.125rem",
  },
  featureStyle: {
    justifyContent: "center",
    alignItems: "center",
    mx: "auto",
    width: "100%",
    gap: "4rem",
    flexDirection: ["column", "column", "column", "row"],
    mb: "4rem",
  },
  buttonStyle: {
    ...typography.h6,
    mt: "1.5rem",
    color: colors.primaryMain,
    cursor: "pointer",
    textDecoration: "none",
  }
};

const styles = {
  carouselWrapper: {
    width: "100%",
    ".carousel-container": {
      width: "100%",
      p: 0,
    },
    ".react-multi-carousel-dot-list": {
      position: "relative !important",
      bottom: "-2rem",
    },
    ".react-multi-carousel-dot": {
      button: {
        border: "none",
        backgroundColor: colors.neutral200,
        "&:hover": {
          backgroundColor: colors.primary100,
        },
        "&:focus": {
          outline: "none",
        },
      },
    },
    ".react-multi-carousel-dot--active": {
      button: {
        backgroundColor: colors.primaryMain,
      },
    },
  },
};

const StyledUL = styled.ul`
	padding-left: 0;
  margin-left: -2.5rem; 
	li {
		margin-bottom: 0.5rem;
		padding-left: 2.25rem;
		list-style: none;
		background-image: url(${bullet});
		background-repeat: no-repeat;
		background-position: left 6px;
		background-size: 18px;
		vertical-align: middle;
		text-align: left;
	}
`;

export default Products;